import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { deleteAPI } from '../api/api';
import { showToast } from '../components/utils/toast';
import { useAnalytics } from './useAnalytics';
import { AnalyticsFeatureOperation } from '../interface/analytics';

const deleteNote = async (notesId: string): Promise<void> => {
  return deleteAPI(`${API_URLS.DELETE_NOTES}${notesId}`);
};

export const useDeleteNote = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>,
  string
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: deleteNote,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.NOTES_DELETED);
      showToast('success', t('note:noteDeleteSuccess'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
